import rawResources from '../../data/rawResources.json';
import inventory from '../../data/objects.json';
import researchDetails from '../../data/researchDetails.json';
const objectNames = Object.keys(inventory);
const resourceNames = Object.keys(rawResources);
const allNames = objectNames.concat(resourceNames).sort((a, b) => (a < b ? -1 : 1));
const getObjectUnlockCost = (objectName) => {
    var _a;
    return ((_a = researchDetails[objectName]) === null || _a === void 0 ? void 0 : _a.bytesRequired) || 0;
};
const getObject = (objectName) => {
    const bytesRequired = getObjectUnlockCost(objectName);
    if (inventory[objectName]) {
        return Object.assign(Object.assign({}, inventory[objectName]), { bytesRequired });
    }
    if (rawResources[objectName]) {
        return Object.assign(Object.assign({}, rawResources[objectName]), { bytesRequired });
    }
    throw new Error(`Object not found ${objectName}`);
};
const getAllObjectsNames = () => allNames;
export { getAllObjectsNames, getObject, getObjectUnlockCost };
